import "regenerator-runtime/runtime";
import axios from 'axios';
let React = require('react');

class InvoiceRequest {

    async getOrderInvoices(OrderId,operatingUnitId, intPage){

        //let APIurl = "https://bepensa.arcadier.io/user/plugins/fd9be114-1e05-4396-9b3e-998f70ad3d44/Gateway_service.php";

        let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.GATEWAY_SERVICE + "/Gateway_service.php";
        //let APIurl = process.env.PROTOCOL + "://" + "bepensa.staging.arcadier.io" + "/user/plugins/" + "b0d13bf2-2763-40e0-a41a-5b4d99019a35" + "/Gateway_service.php";
        // console.log(APIurl);
        const requestBody = {
            'OrderId': OrderId,
        //    "externalOrderID": 27424,
            "operatingUnitId": operatingUnitId,
        //    "CustomerID": 57560,
        //   "StartOrderDate": "2016-09-01T15:52:30.159Z",
        //    "EndOrderDate": "2016-09-29T15:52:30.159Z"
        }
// console.log(requestBody);
        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept' : "*/*"
            }
        };

        var result = {};

        let gatewayRequest = {
            "strEndpointName" : "GetOrders",
            "strMethod" : "POST",
            "strJsonData" : requestBody//,
            //"arrCustomHeaders": []
        }
        // console.log(gatewayRequest);
        await axios.post(APIurl, gatewayRequest, config)
            .then(response => {
                // console.log(response);
                result = JSON.parse(response.data);
                                // console.log(result);
            })
            .catch(error => console.error(error));

        return result.Orders;
    }

    async downloadInvoice(CompanyRFC, CustomerRFC, InvoiceSeries, InvoiceNumber, FileType){

        let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.GATEWAY_SERVICE + "/Gateway_service.php";
        //let APIurl = "https://bepensa.arcadier.io/user/plugins/b0d13bf2-2763-40e0-a41a-5b4d99019a35/Gateway_service.php";

        const requestBody = {
            'CompanyRFC': CompanyRFC,
            'CustomerRFC': CustomerRFC,
            'InvoiceSeries': InvoiceSeries,
            'InvoiceNumber': InvoiceNumber,
            'FileType': FileType
        }
    
        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept' : "*/*"
            }
        };

        var result = {};

        let gatewayRequest = {
            "strEndpointName" : "DescargaFactura",
            "strMethod" : "POST",
            "strJsonData" : requestBody//,
            //"arrCustomHeaders": []
        }

        await axios.post(APIurl, gatewayRequest, config)
        .then(response => {
            result = JSON.parse(response.data);
        })
        .catch(error => console.error(error));
        return result;
    }

   
}

module.exports = InvoiceRequest